/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulActionResponse as DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/CustomResponses/successful-action-response';

export interface RemoveSplitBill$Params {
  billId: string;
  managerPin?: string;
}

export function removeSplitBill(http: HttpClient, rootUrl: string, params: RemoveSplitBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
  const rb = new RequestBuilder(rootUrl, removeSplitBill.PATH, 'delete');
  if (params) {
    rb.path('billId', params.billId, {});
    rb.query('managerPin', params.managerPin, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>;
    })
  );
}

removeSplitBill.PATH = '/api/orders/bills/{billId}/split-bill';
